<template>
    <div>
        <MdTitle v-bind:Text="ViewText"/>
        
        <MdTitle 
         v-bind:Text="TextExport" 
         
         v-bind:VisibleDownload="true"  
         @ClickDownload="Export" 
         v-bind:ReadOnlyDownload="ReadOnlyDownload" 

         v-bind:VisibleEmail1="true" 
         @ClickEmail1="SendEmailProduction" 
         v-bind:ReadOnlyEmail1="ReadOnlyProductionEmail"
         
         v-bind:VisibleTrash="true" 
         v-bind:ReadOnlyTrash="ReadOnlyProductionActions" 
         @ClickTrash="DeleteProduction" 
         
         v-bind:isSubtitle="true" 
         v-bind:Name="'T_TitleSearch'" 
         style="width: 100%;"/> 
        
        <b-row>
            <div class="col-md-6 offset-md-6">
                <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                    <div class="input-group" dir="ltr">
                        <input 
                          type="text" 
                          class="form-control"
                          :dir="dirInput"
                          v-model="SearchCriteria"
                          @keyup.enter="Search()"
                        >
                        <div class="input-group-append">
                            <MdButton 
                              v-bind:Name="'btnsearchinput'"
                              v-bind:VariantProp="'btn btn-sm search-attached'"
                              v-bind:IconClass="'mdi mdi-magnify'"
                              v-on:click="Search()">
                            </MdButton>
                        </div>
                    </div>
                </div>
            </div> 
        </b-row> 


            <div class="row"> 
              <div class="col-md-12"> 
                              <MdTablePaginationClient 
                              v-bind:fields="fields"
                              v-bind:items="items"
                              v-bind:totalRows="totalRows"
                              v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                              v-bind:currentPage="currentPage"
                              v-bind:perPage="perPage"
                              v-bind:pageOptions="pageOptions"
                              v-bind:refTable="'modalViewtabledcs'"                                       
                              :onRowSelected="onRowSelected"
                               :RowClick="RowClick"
                              :onFiltered="onFiltered"
                              :pageChanged="pageChanged"
                              :perPageFunction="PerPageFunction">
                            </MdTablePaginationClient>  
                      </div> 
               
            </div>   
            
            <div class="space-actions"></div>
            <div class="page-actions">
               <MdButton 
                  v-bind:Label="$t('Shared.Back')"
                  v-bind:Name="'btnviewdcslist'"
                  v-bind:ClassProp="'secondary mx-2 btn-login'"
                  v-on:click="DiscardChanges"/>         
            </div>   
            <ModalSendMail
               v-bind:TitleWindow="'Send by E-Mail'"
               @ModalClickOk="SendEmail"  
               v-bind:ModalId="modalSendMail"
               v-bind:Subject="conformSubject">
            </ModalSendMail>
            <MdPasswordDlg v-if="showSignPassword" 
               v-bind:Type="TypePassWord"
               v-bind:VerificationType="'SupervisorPassword'"
               @getModalPassword="onModalPasswordResult($event)"
            />
    </div>
</template>

<script>
 import ShowMessage from '@/components/messages/ShowMessage.js'
 import DCSService from '@/services/dcs.service'

export default {
  name: 'DCSVIEW',
 mixins: [ShowMessage],  
  data(){
    return { 
        ReadOnlyDownload:true,
        ReadOnlyProductionEmail:true,
        ReadOnlyProductionActions:true,       
        TextExport:"",
        ViewText:"",
        isReadOnly:false,
        SearchCriteria:"",
        labelremove:"Remove",
        labelDownload:"Download",
        TypePassWord:"Sign",
        CopyItems:[],
        showSignPassword:false,
        fields:[
          { key: 'email_Address', sortable: true, label: this.$t('Shared.Email'), class: 'text-rigth' },  
          { key: 'phone_Number', sortable: true, label: this.$t('Shared.Phone'), class: 'text-rigth' },
          { key: 'vendor_ID', sortable: true, label: this.$t('dcsview.VendorID'), class: 'text-rigth' },
          { key: 'vendor_Location', sortable: true, label: this.$t('dcsview.VendorLoc'), class: 'text-rigth'},  
          { key: 'vendor_Address_Seq', sortable: true, label: this.$t('dcsview.VendorAddrSeq'), class: 'text-rigth' },
          { key: 'invoice_Type', sortable: true, label: this.$t('dcsview.InvoiceType'), class: 'text-rigth' },
          { key: 'bill_Type', sortable: true, label: this.$t('dcsview.BillType'), class: 'text-rigth' }, 
          { key: 'invoice_Number', sortable: true, label: this.$t('Shared.InvoiceNumber'), class: 'text-rigth' }, 
          { key: 'invoice_Date', sortable: true, label: this.$t('dcsview.InvoiceDate'), class: 'text-rigth' }, 
          { key: 'service_Type', sortable: true, label: this.$t('dcsview.ServiceType'), class: 'text-rigth' }, 
          { key: 'billable_Unit_ID', sortable: true, label: this.$t('dcsview.BillableUnitID'), class: 'text-rigth' }, 
          { key: 'person_ID', sortable: true, label: this.$t('dcsview.PersonID'), class: 'text-rigth' }, 
          { key: 'case_ID', sortable: true, label: this.$t('dcsview.CaseID'), class: 'text-rigth' }, 
          { key: 'billing_Code', sortable: true, label: this.$t('dcsview.BillingCode'), class: 'text-rigth' }, 
          { key: 'service_Code', sortable: true, label: this.$t('dcsview.ServiceCode'), class: 'text-rigth' }, 
          { key: 'component_Code', sortable: true, label: this.$t('dcsview.ComponentCode'), class: 'text-rigth' }, 
          { key: 'start_Date', sortable: true, label: this.$t('Shared.StartDate'), class: 'text-rigth' }, 
          { key: 'end_Date', sortable: true, label: this.$t('Shared.EndDate'), class: 'text-rigth' }, 
          { key: 'units', sortable: true, label: this.$t('Shared.Units'), class: 'text-rigth' }, 
          { key: 'uom', sortable: true, label: 'UOM', class: 'text-rigth' }, 
          { key: 'rate', sortable: true, label: this.$t('dcsview.Rate'), class: 'text-rigth' }, 
          { key: 'amount', sortable: true, label: this.$t('Shared.AmountValCode'), class: 'text-rigth' }, 
          { key: 'county_Code', sortable: true, label: this.$t('dcsview.ConCode')},
          { key: 'comments', sortable: true, label: this.$t('Shared.Comments'), class: 'text-rigth' }, 
         { key: 'place_of_Service', sortable: true, label: this.$t('dcsview.PofService')},
          { key: 'mdrC_1', sortable: true, label: 'MDRC_1', class: 'text-rigth' }, 
          { key: 'mdrC_2', sortable: true, label: 'MDRC_2', class: 'text-rigth' }, 
          { key: 'mdrC_3', sortable: true, label: 'MDRC_3', class: 'text-rigth' }, 
          { key: 'mdrC_4', sortable: true, label: 'MDRC_4', class: 'text-rigth' }, 
          { key: 'mdrC_5', sortable: true, label: 'MDRC_5', class: 'text-rigth' }, 
          { key: 'title', sortable: true, label: this.$t('Patient.Title'), class: 'text-rigth' }, 
          { key: 'type', sortable: true, label: this.$t('Shared.Type'), class: 'text-rigth' },
          { key: 'content', sortable: true, label: this.$t('dcsview.Content'), class: 'text-rigth' },         
        ],
        items:[],
        pageOptions: [15, 30, 45 ],
        totalRows: 0,
        currentPage: 1,
        perPage: 15,
        ShowMessageIsEmpty:false,
        modalSendMail: "modalSendMail",
        conformSubject: this.getSubject(),
         dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
    }
},
 watch: {
    '$route.params': {
      handler() {
        this.updateTexts();
      },
      deep: true,
      immediate: true
    },
    '$i18n.locale': 'updateTexts' // Actualizar cuando cambie el idioma
  },
methods:{

   async DeleteDCS(row){        
        this.$emit('load', true);  
             await DCSService.dcsDelete(row.year, row.month, row.version)
                .then(() => {                
                  this.items = [];

                  this.ReadOnlyProductionActions = true 
                  this.ReadOnlyDownload =  true 
                  this.ReadOnlyProductionEmail = true 

                  this.$emit('load', false);
                  this.showMessage(this.$t('Msg.Success'),'Record deleted!'); 
                })
                .catch((error) => {
                  this.$emit('load', false);  
                    if(error.response.status === 400 ){
                     this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                    }else{
                     this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }                   
                });
   },

   onModalPasswordResult(result){      
          if(result.Event === 'Ok'){   
            if(result.status === true) {   
                this.DeleteDCS({year:this.$route.params.year,month:this.$route.params.monthNumber,version:this.$route.params.version.toString()});  
          }else{
            this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.InvalidSupervisorPass'),"error");
          }
        }
        this.showSignPassword = false;
   },

   DeleteProduction(){       
        this.$bvModal.msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
					title: this.$t('Shared.Reset'),
					okTitle: this.$t('Shared.TitleDelete'),
					cancelTitle: this.$t('Shared.BtnCancel'),
					footerClass: 'p-2',
					titleClass: 'modal-title modal-type-warning',
          id: 'modal_delete_dcs'
				})
          .then(value => {
            if(value){
              this.showSignPassword = true;
            }else{
              this.showSignPassword = false;
            }
          })    
   },

   getSubject() {
      return `${this.$route.params.groupId}ver${this.$route.params.version.toString()}`
   },

   SendEmailProduction(){
      this.$bvModal.show(this.modalSendMail);
   },

   async SendEmail(To, Cc, Subject, Body) {  
        this.$emit('load', true)
        let params = {
            to: To,
            cc: Cc ? Cc : null,
            subject: Subject,
            body: Body ? Body : null,
            groupCreationID: this.$route.params.groupId ? this.$route.params.groupId : null,
            version: this.$route.params.version ? this.$route.params.version.toString() : null
        }
        await DCSService.dcseMail(params).then(response => {
          let resp = response

          if (resp.data.success == true)
            this.showMessage(this.$t('Msg.Success'),this.$t('Shared.Esent'));
          else 
            this.showMessage(this.$tc('Msg.Error'),resp.data.errorMessage,"error");

          this.$emit('load', false);
        }).catch(error => {
          this.$emit('load', false);
          if (!error.response) {
              // network error
              this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
          } else {
              this.showMessage(this.$tc('Msg.Error'),error,"error");
          }
        })
        this.$emit('load', false) 
      },

    Search(){ 
        this.items = this.CopyItems;
        var arr = this.items;
        var temp = [];
        if(this.SearchCriteria){
         arr.forEach(element => {
           if(
           element.email_Address && element.email_Address.toUpperCase().includes(this.SearchCriteria.toUpperCase()) ||
           element.phone_Number && element.phone_Number.toUpperCase().includes(this.SearchCriteria.toUpperCase()) ||
           element.vendor_ID && element.vendor_ID.toUpperCase().includes(this.SearchCriteria.toUpperCase()) ||
           element.vendor_Location && element.vendor_Location.toUpperCase().includes(this.SearchCriteria.toUpperCase()) ||
           element.vendor_Address_Seq && element.vendor_Address_Seq.toUpperCase().includes(this.SearchCriteria.toUpperCase()) ||
           element.invoice_Type && element.invoice_Type.toUpperCase().includes(this.SearchCriteria.toUpperCase()) ||
           element.bill_Type && element.bill_Type.toUpperCase().includes(this.SearchCriteria.toUpperCase()) ||
           element.invoice_Number && element.invoice_Number.toUpperCase().includes(this.SearchCriteria.toUpperCase()) ||
           element.invoice_Date && element.invoice_Date.toUpperCase().includes(this.SearchCriteria.toUpperCase()) ||
           element.service_Type && element.service_Type.toUpperCase().includes(this.SearchCriteria.toUpperCase()) ||
           element.billable_Unit_ID && element.billable_Unit_ID.toUpperCase().includes(this.SearchCriteria.toUpperCase()) ||
           element.person_ID && element.person_ID.toUpperCase().includes(this.SearchCriteria.toUpperCase()) ||
           element.case_ID && element.case_ID.toUpperCase().includes(this.SearchCriteria.toUpperCase()) ||
           element.billing_Code && element.billing_Code.toUpperCase().includes(this.SearchCriteria.toUpperCase()) ||
           element.service_Code && element.service_Code.toUpperCase().includes(this.SearchCriteria.toUpperCase()) ||
           element.component_Code && element.component_Code.toUpperCase().includes(this.SearchCriteria.toUpperCase()) ||
           element.start_Date && element.start_Date.toUpperCase().includes(this.SearchCriteria.toUpperCase()) ||
           element.end_Date && element.end_Date.toUpperCase().includes(this.SearchCriteria.toUpperCase()) ||
           element.units && element.units.toUpperCase().includes(this.SearchCriteria.toUpperCase()) ||
           element.uom && element.uom.toUpperCase().includes(this.SearchCriteria.toUpperCase()) ||
           element.rate && element.rate.toUpperCase().includes(this.SearchCriteria.toUpperCase()) ||
           element.amount && element.amount.toUpperCase().includes(this.SearchCriteria.toUpperCase()) ||
           element.country_Code && element.country_Code.toUpperCase().includes(this.SearchCriteria.toUpperCase()) ||
           element.comments && element.comments.toUpperCase().includes(this.SearchCriteria.toUpperCase()) ||
           element.place_of_Service && element.place_of_Service.toUpperCase().includes(this.SearchCriteria.toUpperCase()) ||
           element.mdrC_1 && element.mdrC_1.toUpperCase().includes(this.SearchCriteria.toUpperCase()) ||
           element.mdrC_2 && element.mdrC_2.toUpperCase().includes(this.SearchCriteria.toUpperCase()) ||
           element.mdrC_3 && element.mdrC_3.toUpperCase().includes(this.SearchCriteria.toUpperCase()) ||
           element.mdrC_4 && element.mdrC_4.toUpperCase().includes(this.SearchCriteria.toUpperCase()) ||
           element.mdrC_5 && element.mdrC_5.toUpperCase().includes(this.SearchCriteria.toUpperCase()) ||
           element.title && element.title.toUpperCase().includes(this.SearchCriteria.toUpperCase()) ||
           element.type && element.type.toUpperCase().includes(this.SearchCriteria.toUpperCase()) ||
           element.content && element.content.toUpperCase().includes(this.SearchCriteria.toUpperCase())        
        ){
              temp.push(element);
           }
        });
        }else{
           temp = this.CopyItems;
        }
      
         this.items = temp;
         this.totalRows = this.items.length;          
       
		this.ShowMessageIsEmpty = this.items.length == 0 ? true : false;
			
     },

     RowClick(){

     },

     Export(){
        this.Download();
     },

     DiscardChanges(){
        this.$router.push({name: "dcs-list"});
     },

     EscapeCaracters(st){
        return st.replace(/"/g, '\\"');
     },

     getContentList() {    
        this.$emit('load', true);          
       DCSService.getContentCSV(this.$route.params.groupId,this.$route.params.version)
            .then((response) => {      
               if (response.data) {              
                this.items = response.data.list;
                this.CopyItems = [...response.data.list];
                this.totalRows = this.items.length;
                this.ReadOnlyProductionEmail = (this.items === null || this.items.length === 0) ? true : false;
                this.ReadOnlyProductionActions = (this.items === null || this.items.length === 0) ? true : false;
                if (this.items.length == 0) {
                  this.ShowMessageIsEmpty = true;
                }
            this.ReadOnlyDownload = (this.items === null || this.items.length === 0) ? true : false;
               }  
               this.$emit('load', false);  
         })
         .catch(error => {
            this.$emit('load', false);  
            if(error.response.status === 400 ){
                 this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
            }else{
               this.showMessage(this.$tc('Msg.Error'),error,"error");
            }
         }); 
            
      },  

     async DownloadUrl(url, filename) {          
           const data = await fetch(url)
           const blob = await data.blob()
           const objectUrl = URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.setAttribute('href', objectUrl)
          link.setAttribute('download', filename)
          link.style.display = 'none'
          document.body.appendChild(link)                          
          link.click()                          
          document.body.removeChild(link)
      },

     Download(){
        var baseurl = this.$store.state.apiurl.replace('/api/', '');            
       DCSService.dcsdownload(this.$route.params.groupId,this.$route.params.version)
            .then((response) => {      
               if (response.data) {
                this.FullUrl = baseurl+response.data.url;   
                this.DownloadUrl(this.FullUrl,response.data.fileName);                
               }                
         })
         .catch(error => {           
            if(error.response.status === 400 ){
                 this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
            }else{
               this.showMessage(this.$tc('Msg.Error'),error,"error");
            }
         }); 
     },

     onRowSelected(){

     },

     onFiltered(){

     },

     pageChanged(page){
        this.currentPage = page;    
     },

     PerPageFunction(perpage){
        this.perPage = perpage;  
        this.currentPage = 1;
     },
     updateTexts() {
         const params = this.$route.params;
         
         this.TextExport = this.$t('dcsview.summary') + " $" + params.totalcharges + 
                        " - " + this.$t('Shared.Transactions') + " " + params.transactions + 
                        " - " + this.$t('dcs.Invoices') + " " + params.invoice;
         
         this.ViewText = this.$t('dcsview.viewProduction') + " - " + 
                        this.$t('Shared.year') + " " + params.year + 
                        " - " + this.$t('Shared.month') + " " + params.month + 
                        " - " + this.$t('Shared.IncVers') + " " + params.version;
      }
    },

    mounted(){
        this.getContentList();
    },
    created() {
      this.updateTexts();
   },
}
   

</script>


